module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "lessonQuiz"
    }
  }, [_c('mu-row', [_c('mu-col', {
    staticClass: "lightbulb-icon quizBg",
    attrs: {
      "width": "30",
      "desktop": "30",
      "tablet": "30"
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "244px"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    attrs: {
      "width": "116px",
      "height": "100%",
      "src": "static/lesson/lightbulb.svg"
    }
  })])], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "70",
      "tablet": "70"
    }
  }, [_c('mu-flexbox', {
    attrs: {
      "align": "center",
      "orient": "vertical"
    }
  }, [_c('mu-flexbox-item', [(!_vm.isQuizComplete) ? _c('mu-card-text', _vm._l((_vm.quiz), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.questionNumberIndex === index),
        expression: "questionNumberIndex === index"
      }],
      key: 'quiz-' + index,
      staticClass: "question"
    }, [_c('div', {
      staticClass: "blueTitle largeTitle"
    }, [_vm._v(_vm._s(_vm.$t('message.quizTestKnowledge')))]), _vm._v(" "), _c('div', {
      staticClass: "bottom",
      domProps: {
        "textContent": _vm._s(_vm.$t('message.questionText') + ' ' + (index + 1) + ': ' + item.question)
      }
    }), _vm._v(" "), _c('div', {
      domProps: {
        "textContent": _vm._s((item.correct === 1) ? _vm.$t('message.selectText') + ' ' + item.correct + ' ' + _vm.$t('message.answerText') : 'Please select ' + item.correct + ' ' + _vm.$t('message.answersText'))
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "answers"
    }, _vm._l((item.answers), function(answer, answerIndex) {
      return _c('div', {
        key: 'quiz-answer-' + answerIndex,
        staticClass: "answer"
      }, [_c('mu-checkbox', {
        attrs: {
          "slot": "left",
          "label": answer.answer,
          "nativeValue": '' + answer.answer_id + '',
          "disabled": _vm.activeAnswerStore.length >= _vm.activeQuestion.correct && _vm.activeAnswerStore.indexOf('' + '' + answer.answer_id + '' + '') === -1
        },
        slot: "left",
        model: {
          value: (_vm.activeAnswerStore),
          callback: function($$v) {
            _vm.activeAnswerStore = $$v
          },
          expression: "activeAnswerStore"
        }
      })], 1)
    }), 0)])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.isQuizComplete) ? _c('mu-card-text', [_c('div', {
    staticClass: "blueTitle largeTitle"
  }, [_vm._v(_vm._s(_vm.$t('message.quizComplete')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.percentage) + "%.")])]) : _vm._e()], 1), _vm._v(" "), _c('mu-flexbox-item', [_c('mu-divider'), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.isQuizComplete === false) ? _c('mu-raised-button', {
    attrs: {
      "type": "button",
      "disabled": (_vm.questions !== _vm.questionNumberIndex) && _vm.activeAnswerStore.length !== _vm.activeQuestion.correct,
      "secondary": "",
      "label": _vm.markable.length === _vm.totalCorrectAnswers ? _vm.$t('message.finishText') : _vm.$t('message.nextText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.nextQuestion()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isQuizComplete === true) ? _c('mu-raised-button', {
    attrs: {
      "type": "button",
      "secondary": "",
      "label": _vm.$t('message.labelTryAgain')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.startAgain()
      }
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6278a57a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lesson/QuizPanel/QuizPanel.vue
// module id = 3197
// module chunks = 1